var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataclaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 116,
    viewBox: "0 0 126 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 126,
    height: 116,
    transform: "translate(125 276)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-125 -276)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Questions-rafiki_1_",
    "data-name": "Questions-rafiki (1)",
    transform: "translate(108 219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-31",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 160.266,
    height: 0.08,
    transform: "translate(0 104.942)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 29.136,
    height: 0.08,
    transform: "translate(115.071 107.994)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 7.978,
    height: 0.08,
    transform: "translate(98.189 107.125)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 12.369,
    height: 0.08,
    transform: "translate(112.032 110.971)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 7.257,
    height: 0.08,
    transform: "translate(16.815 110.433)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 8.619,
    height: 0.08,
    transform: "translate(26.925 110.433)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 15.014,
    height: 0.08,
    transform: "translate(57.154 109.08)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M101.929,145.647H40.037a1.83,1.83,0,0,1-1.827-1.83v-87A1.83,1.83,0,0,1,40.037,55h61.892a1.83,1.83,0,0,1,1.83,1.83v86.986A1.83,1.83,0,0,1,101.929,145.647ZM40.037,55.064a1.75,1.75,0,0,0-1.747,1.75v87a1.75,1.75,0,0,0,1.747,1.75h61.892a1.753,1.753,0,0,0,1.75-1.75v-87a1.753,1.753,0,0,0-1.75-1.75Z",
    transform: "translate(-25.962 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M318.225,145.647H256.33a1.833,1.833,0,0,1-1.83-1.83v-87A1.833,1.833,0,0,1,256.33,55h61.895a1.83,1.83,0,0,1,1.824,1.814v87A1.83,1.83,0,0,1,318.225,145.647ZM256.33,55.064a1.753,1.753,0,0,0-1.75,1.75v87a1.753,1.753,0,0,0,1.75,1.75h61.895a1.753,1.753,0,0,0,1.75-1.75v-87a1.753,1.753,0,0,0-1.75-1.75Z",
    transform: "translate(-172.925 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 6.01,
    height: 33.342,
    transform: "translate(142.621 103.122) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 66.2,
    height: 1.824,
    transform: "translate(141.467 104.942) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 62.497,
    height: 33.342,
    transform: "translate(74.113 69.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 6.141,
    height: 1.59,
    transform: "translate(143.377 69.777) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 63.879,
    height: 1.59,
    transform: "translate(73.357 68.187)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M296.167,291.8H238V283.11h58.167Zm-57.776-.394h57.375v-7.885H238.391Z",
    transform: "translate(-161.713 -209.993)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M296.167,333.312H238V317.75h58.167Zm-57.776-.417h57.375V318.151H238.391Z",
    transform: "translate(-161.713 -233.53)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 42.503,
    height: 1.295,
    rx: 0.647,
    transform: "translate(126.613 74.61) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 42.503,
    height: 1.295,
    rx: 0.647,
    transform: "translate(126.613 85.717) rotate(180)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 2.497,
    height: 42.438,
    transform: "translate(20.799 104.942) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 1.734,
    height: 42.438,
    transform: "translate(19.251 104.942) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 29.707,
    height: 3.067,
    transform: "translate(16.979 62.504)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 2.497,
    height: 39.368,
    transform: "translate(50.301 104.942) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 1.734,
    height: 39.368,
    transform: "translate(48.753 104.942) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 2.497,
    height: 39.368,
    transform: "translate(66.107 104.942) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 1.734,
    height: 39.368,
    transform: "translate(64.552 104.942) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 2.497,
    height: 39.368,
    transform: "translate(36.605 104.942) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 1.734,
    height: 39.368,
    transform: "translate(35.053 104.942) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 19.418,
    height: 3.067,
    transform: "translate(66.107 65.571) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M86.915,136.581h-24L65.035,118H84.79Z",
    transform: "translate(-42.745 -97.806)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 2.612,
    height: 23.729,
    transform: "translate(30.861 38.775)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M94.4,247.595H83.74a1.135,1.135,0,0,1,1.135-1.135h8.382a1.135,1.135,0,0,1,1.144,1.135Z",
    transform: "translate(-56.899 -185.091)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M98.892,178.025l-2.612-1.247v-.808h2.612Z",
    transform: "translate(-65.419 -137.195)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M135.39,217.332h11.273l1.394-15.312H136.784Z",
    transform: "translate(-91.993 -154.895)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M133.57,217.332h11.273l1.394-15.312H134.964Z",
    transform: "translate(-90.757 -154.895)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M147.222,219.231l1.087-11.921h-7.882l-1.087,11.921Z",
    transform: "translate(-94.677 -158.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M366.845,215.53H343.962l-4.452,15.857h22.883Z",
    transform: "translate(-230.686 -164.075)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M362.189,265l-.09.875H339.21L339.3,265Z",
    transform: "translate(-230.482 -197.688)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M364.648,215.53H341.762l-4.452,15.857H360.2Z",
    transform: "translate(-229.191 -164.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M362.086,231.887l3.683-13.732c.051-.2-.048-.365-.215-.365h-21.04a.4.4,0,0,0-.346.321l-3.68,13.722c-.055.2.045.365.212.365h21.04a.394.394,0,0,0,.346-.311Z",
    transform: "translate(-231.341 -165.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M336.483,265l-.093.875h-25.2l.093-.875Z",
    transform: "translate(-211.444 -197.688)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 55.523,
    height: 34.268,
    transform: "translate(85.377 10.078)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 52.369,
    height: 31.117,
    transform: "translate(86.954 11.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 0.567,
    height: 34.268,
    transform: "translate(141.467 44.349) rotate(180)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-31",
    transform: "translate(17.985 167.161)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-31",
    cx: 62.148,
    cy: 3.628,
    rx: 62.148,
    ry: 3.628,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-31",
    transform: "translate(50.644 57.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M174.8,64.054a11.478,11.478,0,0,1,5.811-2.616,14.821,14.821,0,0,1,7.542.785,17.7,17.7,0,0,1,7.247,5.071,18.339,18.339,0,0,1,4.128,7.145,13.106,13.106,0,0,1,.189,7.093,11.251,11.251,0,0,1-3.43,5.6,9.728,9.728,0,0,1-4.228,2.324,14.3,14.3,0,0,1-4.324.4q-2.093-.135-7.263-.715a22.96,22.96,0,0,0-2.43-.135,6.9,6.9,0,0,0-1.651.189,6.554,6.554,0,0,0-1.244.455c-.385.189-1.035.538-1.958,1.055q-2.846,1.74-4.949-.609a3.846,3.846,0,0,1-1.042-2.773,4.224,4.224,0,0,1,1.628-2.959,11.171,11.171,0,0,1,7.959-3.1,50.094,50.094,0,0,1,5.036.423c1.776.215,3.087.349,3.933.394a8.995,8.995,0,0,0,2.5-.208,4.808,4.808,0,0,0,2.2-1.138,5.584,5.584,0,0,0,1.923-4.241,6.875,6.875,0,0,0-1.923-4.766q-2.317-2.587-4.715-2.638a14.076,14.076,0,0,0-5.709,1.378q-3.369,1.58-5.369-.641a4,4,0,0,1-1.061-3.051,3.846,3.846,0,0,1,1.2-2.718ZM159.31,98.573A4.962,4.962,0,0,1,158,95.236a4.378,4.378,0,0,1,1.638-3.394,4.5,4.5,0,0,1,3.42-1.183,4.689,4.689,0,0,1,3.282,1.635,4.628,4.628,0,0,1-.369,6.638,4.4,4.4,0,0,1-3.526,1.256,4.808,4.808,0,0,1-3.135-1.615Z",
    transform: "translate(-157.998 -61.25)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278",
    transform: "translate(44.669 20.158)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M298.157,128.278a6.09,6.09,0,0,1,2.151-2.648,7.968,7.968,0,0,1,3.8-1.436,9.488,9.488,0,0,1,4.689.686,9.859,9.859,0,0,1,3.693,2.42,7.032,7.032,0,0,1,1.795,3.35,6.042,6.042,0,0,1-.288,3.526,5.2,5.2,0,0,1-1.468,2.128,7.658,7.658,0,0,1-1.974,1.231q-1.032.439-3.651,1.4a11.218,11.218,0,0,0-1.2.519,3.6,3.6,0,0,0-.744.487,3.343,3.343,0,0,0-.487.516c-.138.183-.365.506-.683.962a1.886,1.886,0,0,1-2.516.9,2.067,2.067,0,0,1-1.167-1.077,2.244,2.244,0,0,1,.071-1.808,5.988,5.988,0,0,1,3.064-3.4,27.048,27.048,0,0,1,2.51-1.019c.9-.321,1.561-.574,1.978-.753a4.833,4.833,0,0,0,1.147-.7,2.593,2.593,0,0,0,.779-1.074,2.981,2.981,0,0,0-.1-2.491,3.67,3.67,0,0,0-2.061-1.8,3.569,3.569,0,0,0-2.885-.131,7.442,7.442,0,0,0-2.4,2.026,2.22,2.22,0,0,1-2.731.962,2.151,2.151,0,0,1-1.24-1.208A2.032,2.032,0,0,1,298.157,128.278Zm.875,20.258a2.664,2.664,0,0,1-1.43-1.282,2.346,2.346,0,0,1-.038-2,2.4,2.4,0,0,1,1.349-1.394,2.539,2.539,0,0,1,3.385,3.266,2.356,2.356,0,0,1-1.391,1.449,2.564,2.564,0,0,1-1.875-.035Z",
    transform: "translate(-297.358 -124.14)",
    fill: "#ce8045"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(66.581 16.629)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M366.164,118.908a2.856,2.856,0,0,1-.446-1.526,3.673,3.673,0,0,1,.455-1.833,4.375,4.375,0,0,1,1.5-1.6,4.577,4.577,0,0,1,1.9-.776,3.282,3.282,0,0,1,1.76.2,2.818,2.818,0,0,1,1.282,1.042,2.426,2.426,0,0,1,.43,1.125,3.645,3.645,0,0,1-.051,1.08q-.106.516-.43,1.769a5.915,5.915,0,0,0-.115.6,1.634,1.634,0,0,0,.058.737c.035.1.1.276.2.519a.875.875,0,0,1-.321,1.2.962.962,0,0,1-.718.16,1.039,1.039,0,0,1-.676-.5,2.92,2.92,0,0,1-.468-1.064,2.885,2.885,0,0,1-.022-1.006,12.029,12.029,0,0,1,.272-1.231c.115-.433.192-.75.234-.962a2.411,2.411,0,0,0,.035-.641,1.224,1.224,0,0,0-.208-.583,1.391,1.391,0,0,0-.981-.619,1.7,1.7,0,0,0-1.244.321,1.673,1.673,0,0,0-.814,1.071,3.474,3.474,0,0,0,.144,1.455,1.043,1.043,0,0,1-.349,1.3,1,1,0,0,1-.789.157A.962.962,0,0,1,366.164,118.908Zm8,5.02a1.253,1.253,0,0,1-.869.208,1.087,1.087,0,0,1-.782-.522,1.122,1.122,0,0,1-.179-.885,1.176,1.176,0,0,1,.516-.756,1.144,1.144,0,0,1,.881-.183,1.128,1.128,0,0,1,.747.5,1.106,1.106,0,0,1,.189.917A1.209,1.209,0,0,1,374.162,123.927Z",
    transform: "translate(-365.718 -113.128)",
    fill: "#ce8045"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-31",
    transform: "translate(50.745 69.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M180.653,396.54l-2.423-.628,1.446-5.542L182.1,391Z",
    transform: "translate(-171.847 -297.478)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M167.456,405.589l2.705.856a.173.173,0,0,1,.125.215l-.571,2.1a.455.455,0,0,1-.564.279c-.936-.32-1.369-.506-2.564-.885-.734-.231-2.5-.753-3.526-1.074s-.641-1.282-.2-1.221a9.315,9.315,0,0,0,4.109-.256.747.747,0,0,1,.481-.013Z",
    transform: "translate(-161.098 -307.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M183.587,391.008l-2.423-.628-.744,2.856,2.423.628Z",
    transform: "translate(-173.335 -297.484)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M188.755,215.53s-4.436,21.081-5.616,27.982c-1.282,7.558-4.1,29.2-4.1,29.2l4.119,1.5s6.446-22.947,7.424-30.213c2.048-7.1,7.238-28.463,7.238-28.463Z",
    transform: "translate(-172.397 -178.679)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M223.364,234.309c-1.439,3.455-1.962,9.747-1.712,13.51,1.141-4.443,2.407-9.517,3.388-13.491C224.723,233.235,224.287,232.087,223.364,234.309Z",
    transform: "translate(-201.31 -190.576)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M182.267,393.444l-4.417-1.276.167-1.869,5.257,1.478Z",
    transform: "translate(-171.589 -297.43)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M174.123,404.611a3.284,3.284,0,0,0,.67.119.06.06,0,0,0,.058-.09c-.061-.077-.59-.74-.92-.721a.224.224,0,0,0-.186.112.321.321,0,0,0-.029.321A.679.679,0,0,0,174.123,404.611Zm.545,0c-.462-.055-.772-.167-.849-.321a.2.2,0,0,1,.026-.205.112.112,0,0,1,.09-.058c.173-.006.513.317.734.577Z",
    transform: "translate(-168.76 -306.684)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M176.424,403.964h.029a.061.061,0,0,0,.045-.032c0-.029.295-.68.128-.981a.32.32,0,0,0-.212-.151.231.231,0,0,0-.26.1,1.212,1.212,0,0,0,.244,1.045A.051.051,0,0,0,176.424,403.964Zm0-1.045a.17.17,0,0,1,.1.087,1.209,1.209,0,0,1-.093.785,1.1,1.1,0,0,1-.17-.833c0-.029.048-.061.131-.045Z",
    transform: "translate(-170.403 -305.918)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M182.989,153.948c-.215.519-.42.981-.641,1.455s-.458.939-.7,1.4c-.487.926-1,1.84-1.564,2.731a25.094,25.094,0,0,1-4.039,5.055l-.058.058a1.365,1.365,0,0,1-.269.189,2.244,2.244,0,0,1-.862.26,3.636,3.636,0,0,1-.519,0,5.377,5.377,0,0,1-.769-.106c-.455-.1-.859-.215-1.256-.34-.789-.25-1.523-.555-2.244-.862s-1.433-.641-2.132-1-1.385-.724-2.064-1.135a.776.776,0,0,1,.583-1.417h0c1.487.359,2.971.76,4.433,1.115.728.183,1.455.343,2.154.478a9,9,0,0,0,1,.144,3.258,3.258,0,0,0,.378,0h.054a.622.622,0,0,0-.321.1l-.321.247a21.384,21.384,0,0,0,1.721-2.173c.538-.779,1.048-1.6,1.539-2.43s.962-1.7,1.407-2.564.888-1.763,1.282-2.6l.019-.042A1.754,1.754,0,0,1,183,153.939Z",
    transform: "translate(-163.198 -135.153)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M208.274,148.617c-2.064.058-3.481,2.3-4.834,5.09a11.921,11.921,0,0,0,4.311,4.327S213.175,148.479,208.274,148.617Z",
    transform: "translate(-188.976 -133.213)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M162.4,178.327l-1.859-.474,1.449-1.862a3.136,3.136,0,0,1,2.212,1.6l-.66.471a1.407,1.407,0,0,1-1.141.263Z",
    transform: "translate(-159.827 -151.813)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M158.577,174.744l.359-.321A.83.83,0,0,1,160,174.4l.474.381-1.449,1.862-.593-.923a.753.753,0,0,1,.141-.978Z",
    transform: "translate(-158.316 -150.609)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M246.8,396.748h-2.535l-.606-5.648H246.2Z",
    transform: "translate(-216.305 -297.974)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M234.625,407.839h2.85a.18.18,0,0,1,.189.167l.138,2.167a.446.446,0,0,1-.446.436c-.99-.019-1.465-.074-2.718-.074-.769,0-2.885.077-3.959.077s-1.035-1.013-.583-1.1a10.785,10.785,0,0,0,4.093-1.519A.718.718,0,0,1,234.625,407.839Z",
    transform: "translate(-206.885 -309.347)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M246.2,391.1H243.66l.314,2.914h2.535Z",
    transform: "translate(-216.305 -297.974)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M224.81,215.516s.561,21.194.962,28.178c.449,7.648,4.247,30.306,4.247,30.306h4.648s-1.019-22.947-1.789-30.451c.321-8.218.532-28.04.532-28.04Z",
    transform: "translate(-203.497 -178.666)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M244.44,394.4h-5.27l-.25-1.7,5.661.1Z",
    transform: "translate(-213.084 -299.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M240.852,407.856a3.242,3.242,0,0,0,.676-.087.058.058,0,0,0,.019-.1c-.08-.051-.8-.526-1.109-.407a.218.218,0,0,0-.138.16.3.3,0,0,0,.074.321A.708.708,0,0,0,240.852,407.856Zm.513-.167c-.455.087-.789.07-.907-.042a.2.2,0,0,1-.042-.2.106.106,0,0,1,.064-.08C240.647,407.3,241.07,407.507,241.365,407.689Z",
    transform: "translate(-214.01 -308.941)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M242.83,406.588h.029a.067.067,0,0,0,.032-.048c0-.029.058-.731-.2-.962a.292.292,0,0,0-.25-.077.224.224,0,0,0-.215.17c-.058.266.321.776.574.92Zm-.359-.99a.173.173,0,0,1,.128.051,1.221,1.221,0,0,1,.167.776c-.221-.18-.474-.567-.436-.74,0-.035.029-.074.115-.083Z",
    transform: "translate(-215.327 -307.756)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M209.788,149.4a2.433,2.433,0,0,1,1.872-1.632,15.533,15.533,0,0,1,1.9-.321,52.337,52.337,0,0,1,5.77,0c1.006.045,2.032.163,2.85.279h.029a1.558,1.558,0,0,1,1.356,1.808,73.982,73.982,0,0,0-1.253,9.895c-.2,4.827.071,8.616-.026,9.779H208.72C207.9,157.439,208.961,152.086,209.788,149.4Z",
    transform: "translate(-192.362 -132.368)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M238.693,124.97a1.686,1.686,0,0,1-.253,2.885c.548.907-.91,2.51-2.378,1.5S236.667,124.114,238.693,124.97Z",
    transform: "translate(-210.805 -117.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M223.227,114.735a1.164,1.164,0,0,1-1.074-1.686c-.683-.266-.561-1.757.67-1.821S224.688,114.36,223.227,114.735Z",
    transform: "translate(-201.41 -107.809)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M224.637,136.153a.718.718,0,0,1,.253-1.208,1.974,1.974,0,0,0,1.362-2.33,6.892,6.892,0,0,0-.135-.817l2.1-1.676,1.545-1.231c-.385,1.6-.814,4.395,0,5.808a.728.728,0,0,1-.147.936,4.661,4.661,0,0,1-3.417.984A2.551,2.551,0,0,1,224.637,136.153Z",
    transform: "translate(-203.221 -119.81)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M206.976,149.519a2.824,2.824,0,0,1,2.055-1.866,17.385,17.385,0,0,1,1.837-.192.391.391,0,0,1,.433.49,73.533,73.533,0,0,0-2.132,21.847.452.452,0,0,1-.462.468h-2.692a.458.458,0,0,1-.465-.423C204.739,157.77,206.172,151.754,206.976,149.519Z",
    transform: "translate(-190.246 -132.426)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M240.041,147.233a25.464,25.464,0,0,0-2.6-.237h0a.67.67,0,0,0-.7.506c-1,4.391-1.885,14.148-1.923,22a.455.455,0,0,0,.465.446h4.808a.455.455,0,0,0,.465-.436c.032-1.58-.186-5.282,0-9.879a68.913,68.913,0,0,1,1.231-9.751A2.728,2.728,0,0,0,240.041,147.233Z",
    transform: "translate(-210.298 -132.112)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M249.548,150.391c1.029,1.551,1.965,3.106,2.85,4.737.436.817.865,1.648,1.253,2.519.192.436.381.881.558,1.353a9.519,9.519,0,0,1,.449,1.571,3.808,3.808,0,0,1,.051,1.186,5.127,5.127,0,0,1-.247.939,9.485,9.485,0,0,1-.67,1.436,21.958,21.958,0,0,1-1.574,2.4,39.009,39.009,0,0,1-3.628,4.186.872.872,0,0,1-1.359-1.074v-.019c.933-1.5,1.875-3.035,2.728-4.555.423-.756.827-1.526,1.151-2.269s.561-1.558.394-1.58a8.254,8.254,0,0,0-.372-1c-.16-.365-.343-.744-.535-1.119-.391-.753-.811-1.519-1.25-2.273-.878-1.513-1.814-3.039-2.741-4.516v-.019a1.752,1.752,0,0,1,2.943-1.9Z",
    transform: "translate(-218.115 -133.875)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M246.367,147.609c2.064-.038,3.157,1.708,4.51,4.487a10.034,10.034,0,0,1-4.455,4.064S242.309,147.679,246.367,147.609Z",
    transform: "translate(-216.928 -132.529)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M244.339,211.626,243.15,212l2.2,1.673s1.8-.936,1.237-1.785l-.365-.163a2.67,2.67,0,0,0-1.885-.1Z",
    transform: "translate(-215.958 -175.942)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M240.827,214.538l1.337,1.343a.436.436,0,0,0,.641-.035l.888-1.1-2.2-1.673-.686.939A.391.391,0,0,0,240.827,214.538Z",
    transform: "translate(-214.302 -177.008)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M229.75,134.446a6.889,6.889,0,0,1,.135.817,1.986,1.986,0,0,0,2.029-1.481,4.924,4.924,0,0,0-.064-1.013Z",
    transform: "translate(-206.853 -122.447)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M229.322,113.317c-.542,2.366-.734,3.776-2.189,4.83a3.337,3.337,0,0,1-5.292-2.382c-.186-2.218.731-5.715,3.321-6.337A3.309,3.309,0,0,1,229.322,113.317Z",
    transform: "translate(-201.463 -106.513)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M229.044,109.438c-.686.035-1.417-2.385.1-3.551-.24.131-.9-.109-.782-.561-.446.186-2.394.106-1.923-.686-.99.256-3.151-.173-3.382-1.119s.885-.978,1.058-.853a1.245,1.245,0,0,1,.821-2.058c1.3-.365,3.263,1.516,3.263,1.516-.205-.5.516-.9,1.263-.471a3.171,3.171,0,0,1,1.1,1.638c0-.365,1.744.125.917,1.657.856.321,1.247.776,1.192,1.567s-.6.837-.6.837a1.375,1.375,0,0,1-.471,1.628C230.708,109.7,229.932,108.857,229.044,109.438Z",
    transform: "translate(-202.282 -100.563)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M241.839,125.969a2.308,2.308,0,0,1-1.26.914c-.66.176-.885-.413-.615-1.029.244-.555.878-1.317,1.5-1.221S242.211,125.418,241.839,125.969Z",
    transform: "translate(-213.718 -116.912)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M231.966,120.675c-.032.192-.167.337-.3.321s-.215-.189-.183-.385a.345.345,0,0,1,.3-.321C231.915,120.29,231.982,120.479,231.966,120.675Z",
    transform: "translate(-208.028 -113.967)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M224.653,119.345c-.032.2-.163.34-.295.321s-.215-.189-.183-.385a.342.342,0,0,1,.295-.321C224.6,118.96,224.685,119.152,224.653,119.345Z",
    transform: "translate(-203.061 -113.063)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M225.94,121.52a7.2,7.2,0,0,1-1.24,1.529,1.2,1.2,0,0,0,.939.321Z",
    transform: "translate(-203.422 -114.803)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M228.329,129.245a1.763,1.763,0,0,0,1.311-.385.061.061,0,0,0,0-.083.064.064,0,0,0-.083,0,1.689,1.689,0,0,1-1.439.321.058.058,0,0,0-.071.045.054.054,0,0,0,.045.067A1.635,1.635,0,0,0,228.329,129.245Z",
    transform: "translate(-205.694 -119.723)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M233.116,117.311a.119.119,0,0,0-.051.029.112.112,0,0,0,0,.163,1.16,1.16,0,0,0,1.006.378.112.112,0,0,0,.1-.131.119.119,0,0,0-.138-.1.926.926,0,0,1-.785-.321A.128.128,0,0,0,233.116,117.311Z",
    transform: "translate(-209.082 -111.937)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M223.478,114.777a.138.138,0,0,0,.112,0,1.045,1.045,0,0,1,.885-.022.116.116,0,1,0,.115-.2h0a1.282,1.282,0,0,0-1.109,0,.109.109,0,0,0-.051.154.125.125,0,0,0,.048.071Z",
    transform: "translate(-202.549 -109.983)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataclaim);
export default __webpack_public_path__ + "static/media/nodataclaim.cde63c583b8ab9ace4a34b85fe805e0b.svg";
export { ForwardRef as ReactComponent };